import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { getFormatedDate, fancyTimeFormat } from "../../../Js/TimeAndDate";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";

const CardAssetList = (props) => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { siteConfig } = useSelector((state) => state.defs);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const redirect = (course) => {
    if (
      props.resAssetData.assetType &&
      props.resAssetData.assetType != "BOOK"
    ) {
      dispatch(currentAssetSliceActions.setAttempedAnsLog(course));
      navigation(`/Report/LearnerContent/${course.context.assetId}`);
    }
  };

  // console.log("CardAssetList", props.resAssetData);
  return (
    <Box sx={{ width: "100%", borderRadius: 3, backgroundColor: "#F5F7FF" }}>
      <Accordion
        expanded={expanded === "panel" + props.index}
        onChange={handleChange("panel" + props.index)}
        sx={{
          backgroundColor: "#F5F7FF",
          boxShadow: 0,
          my: 1,
          "@media (min-width: 1636px)": {
            borderBottom: 4,
            borderBottomColor: "#FFFFFF",
          },
        }}
        key={`accordion_${props.index}`}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "primary.main" }} />}
        >
          <Box sx={{ textAlign: "left" }}>
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "700",
                fontSize: "1rem",
                "@media (min-width: 1636px)": { fontSize: "1.4rem" },
              }}
            >
              {props.resAssetData.assetName}
            </Typography>
            <Typography
              sx={{
                fontSize: "0.8rem",
                color: "#A9A9A9",
                "@media (min-width: 1636px)": { fontSize: "1rem" },
              }}
            >
              Asset Type: {props.resAssetData.assetType}
            </Typography>
            <Typography
              sx={{
                fontSize: "0.8rem",
                color: "#A9A9A9",
                "@media (min-width: 1636px)": { fontSize: "1rem" },
              }}
            >
              Task name: {props.resAssetData.taskName}
            </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer>
            <Table sx={{ minWidth: 400 }}>
              <TableHead>
                <TableRow>
                  <TableCell
                    align="center"
                    sx={{
                      color: "#DB8829",
                      fontSize: "0.8rem",
                      fontWeight: "600",
                      padding: "1px",
                      "@media (min-width: 1636px)": { fontSize: "1rem" },
                    }}
                  >
                    No
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color: "#DB8829",
                      fontSize: "0.8rem",
                      fontWeight: "600",
                      padding: "1px",
                      "@media (min-width: 1636px)": { fontSize: "1rem" },
                    }}
                  >
                    Date
                  </TableCell>
                  {!siteConfig?.customer?.addOnInfo?.isEstimatedDuration && (
                    <TableCell
                      align="center"
                      sx={{
                        color: "#DB8829",
                        fontSize: "0.8rem",
                        fontWeight: "600",
                        padding: "1px",
                        "@media (min-width: 1636px)": { fontSize: "1rem" },
                      }}
                    >
                      Duration (MM:SS)
                    </TableCell>
                  )}
                  <TableCell
                    align="center"
                    sx={{
                      color: "#DB8829",
                      fontSize: "0.8rem",
                      fontWeight: "600",
                      padding: "1px",
                      "@media (min-width: 1636px)": { fontSize: "1rem" },
                    }}
                  >
                    Score
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color: "#DB8829",
                      fontSize: "0.8rem",
                      fontWeight: "600",
                      padding: "1px",
                      "@media (min-width: 1636px)": { fontSize: "1rem" },
                    }}
                  >
                    Attempts
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color: "#DB8829",
                      fontSize: "0.8rem",
                      fontWeight: "600",
                      padding: "1px",
                      "@media (min-width: 1636px)": { fontSize: "1rem" },
                    }}
                  >
                    Device
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color: "#DB8829",
                      fontSize: "0.8rem",
                      fontWeight: "600",
                      padding: "1px",
                      "@media (min-width: 1636px)": { fontSize: "1rem" },
                    }}
                  >
                    Version
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.resAssetData.data.map((course, courseIndex) => {
                  return (
                    <TableRow
                      key={courseIndex}
                      sx={{ py: 0, cursor: "pointer" }}
                      onClick={() => {
                        redirect(course);
                      }}
                    >
                      <TableCell
                        align="center"
                        sx={{
                          color: "#DB8829",
                          fontSize: "0.7rem",
                          fontWeight: "500",
                          padding: "10px",
                          "@media (min-width: 1636px)": { fontSize: "0.9rem" },
                        }}
                      >
                        <b>{courseIndex + 1}</b>
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          color: "#DB8829",
                          fontSize: "0.7rem",
                          fontWeight: "500",
                          padding: "10px",
                          "@media (min-width: 1636px)": { fontSize: "0.9rem" },
                        }}
                      >
                        <b>
                          {getFormatedDate(
                            course.createdAt,
                            "DD MMM YY, HH:mm:ss"
                          )}
                        </b>
                      </TableCell>
                      {!siteConfig?.customer?.addOnInfo
                        ?.isEstimatedDuration && (
                        <TableCell
                          align="center"
                          sx={{
                            color: "#DB8829",
                            fontSize: "0.7rem",
                            fontWeight: "500",
                            padding: "10px",
                            "@media (min-width: 1636px)": {
                              fontSize: "0.9rem",
                            },
                          }}
                        >
                          <b>{fancyTimeFormat(course.outcome.duration)}</b>
                        </TableCell>
                      )}
                      <TableCell
                        align="center"
                        sx={{
                          color: "#DB8829",
                          fontSize: "0.7rem",
                          fontWeight: "500",
                          padding: "10px",
                          "@media (min-width: 1636px)": { fontSize: "0.9rem" },
                        }}
                      >
                        <b>{Number(course.outcome.genericScore).toFixed(2)}</b>
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          color: "#DB8829",
                          fontSize: "0.7rem",
                          fontWeight: "500",
                          padding: "10px",
                          "@media (min-width: 1636px)": { fontSize: "0.9rem" },
                        }}
                      >
                        {course.outcome.assetType.value == "SB" ? (
                          <b>-</b>
                        ) : course.outcome.userAnswer ? (
                          <b>{course.outcome.attempts}</b>
                        ) : (
                          <b>1</b>
                        )}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          color: "#DB8829",
                          fontSize: "0.8rem",
                          fontWeight: "600",
                          padding: "1px",
                          "@media (min-width: 1636px)": {
                            fontSize: "1rem",
                          },
                        }}
                      >
                        {course.outcome.deviceType
                          ? course.outcome.deviceType
                          : "NA"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          color: "#DB8829",
                          fontSize: "0.8rem",
                          fontWeight: "600",
                          padding: "1px",
                          "@media (min-width: 1636px)": {
                            fontSize: "1rem",
                          },
                        }}
                      >
                        {course.outcome.applicationVersion
                          ? course.outcome.applicationVersion
                          : "NA"}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
export default CardAssetList;
